module.exports = __webpack_public_path__ + "static/media/newyork2.330bd3a6.jpeg";